export default {
  methods: {
    getInvoiceStatus: function (invoiceStatus: string) {
      const obj = { status: invoiceStatus, label: '', color: '' }
      switch (invoiceStatus) {
        case 'receive':
          obj.label = 'Recibida'
          obj.color = '#49BEFFFF'
          break
        case 'assignee':
          obj.label = 'Asignada'
          obj.color = '#13DEB9FF'
          break
        case 'withoutProject':
          obj.label = 'Sin Proyecto'
          obj.color = 'warning'
          break
        case 'rejected':
          obj.label = 'Rechazada'
          obj.color = 'rgb(250, 137, 107)'
          break
        case 'charged':
          obj.label = 'Cobrada'
          obj.color = 'rgb(93, 135, 255)'
          break
      }
      return obj
    },
    getInvoiceStatusList: function () {
      return [
        { id: 'receive', name: 'Recibida' },
        { id: 'assignee', name: 'Asignada' },
        { id: 'withoutProject', name: 'Sin Proyecto' },
        { id: 'rejected', name: 'Rechazada' },
        { id: 'charged', name: 'Cobrada' }
      ]
    }
  }
}
